import {Component, OnInit} from '@angular/core';
import {IsActiveMatchOptions, Router} from '@angular/router';

import {delay, tap} from 'rxjs/operators';

import {TasksService} from './services/tasks.service';

import {Destroyable} from '../../destroyable.component';

@Component({
  selector: 'gp-workflows',
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss']
})
export class WorkflowsComponent extends Destroyable implements OnInit {
  public showDetailView = false;
  readonly isActiveMatchOptions: IsActiveMatchOptions = {
    queryParams: 'ignored',
    matrixParams: 'subset',
    paths: 'subset',
    fragment: 'ignored'
  };

  constructor(private router: Router, private tasksService: TasksService) {
    super();
  }


  public backToList(): void {
    this.router.navigate(['/inbox/tasks'], {queryParams: {status: 'IN_PROGRESS'}});
  }

  public ngOnInit(): void {
    this.tasksService.taskIdLastViewed$
      .pipe(
        delay(0),
        tap((taskId: string) => this.showDetailView = !!taskId)
      ).subscribe();
  }

}
